import { useRef } from "react";
import { animated, useChain, useSpring } from "react-spring";
import { useRecoilValue } from "recoil";
import { getCurrentContent } from "selectors/controller";
import { appStrings } from "utils/appStrings";
import { getAnswerStatus } from "utils/functions";
import ReactHTMLParser from "react-html-parser";
import { toPersian } from "utils/raqam";

const Answer: React.FC = () => {
  const content = useRecoilValue(getCurrentContent);
  const isCorrect = getAnswerStatus(content.userAnswer, content.correctAnswer);

  //Animation

  const resultRef = useRef(null);
  const descRef = useRef(null);
  const answerRef = useRef(null);

  const resultAnimation = useSpring({
    ref: resultRef,
    opacity: 1,
    from: { opacity: 0 },
  });

  const answerAnimation = useSpring({
    ref: answerRef,
    opacity: 1,
    from: { opacity: 0 },
  });

  const descAnimation = useSpring({
    ref: descRef,
    transform: "scale(1)",
    from: { transform: "scale(0)" },
  });

  useChain(
    [
      { current: resultRef.current },
      { current: answerRef.current },
      { current: descRef.current },
    ],
    [0, 0.2, 0.4]
  );

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <animated.p
        style={resultAnimation}
        className={`text-center text-xl font-semibold mb-6 ${
          isCorrect
            ? "text-green-700 dark:text-green-300"
            : "text-red-700 dark:text-red-400"
        }`}
      >
        {isCorrect ? appStrings.correct : appStrings.wrong}
      </animated.p>
      <animated.p
        style={answerAnimation}
        className="dark:text-gray-100 leading-loose font-semibold text-center mb-6"
      >
        {isCorrect
          ? ""
          : ReactHTMLParser(toPersian(content.correctAnswer[0].body, {}))}
      </animated.p>
      <animated.p
        style={descAnimation}
        className="dark:text-gray-100 leading-loose"
      >
        {ReactHTMLParser(content.solution)}
      </animated.p>
    </div>
  );
};

export default Answer;
